import React from "react";
import gernet from '../../assets/images/Gernet.jpg';

const MainPage = (p) => {
  return (
    <div className="page-content main-page-content">
      <div>
      <p className="title text-center">Interesaĵoj</p>
      <figure>
        <img src={gernet} alt="Gernet" />
        <figcaption>
          Pioniro de Esperanto, esperantistiĝis en 1890, jam en 1894 grupiĝis ĉirkaŭ li aro da fervoraj
          esperantistoj en Odeso. Kunfondinto de la Lingvo Internacia (fama gazeto 1895-1914),
          kiun li monsubtenis. Longe korespondis kun Zamenhof.
        </figcaption>
      </figure>
      </div>
    </div>
  )
}


export default MainPage;